<template>
    <div class="form-group form-row">
        <div class="col-12">
            <label>{{ $t(label) }}</label>
        </div>
        <div class="col-12 col-sm-10">
            <v-select
                :options="options"
                :get-option-label="getLabel"
                :reduce="options => options"
                v-model="selected"
                id="style"
            >
                <template #search="{attributes, events}">
                    <input
                        class="vs__search"
                        v-bind="attributes"
                        v-on="events"
                        @input="fetchOptions"
                        v-model="searchInput"
                    />
                </template>
                <template #no-options="{}">
                    {{ $t("selectError") }}
                </template>
            </v-select>
        </div>
        <div class="col-12 col-sm-2 mt-2 mt-sm-0">
            <IconButton :icon="icon" size="md" style="width: 100%" class="h-11" :do-action="pushToModels"/>
        </div>
    </div>
</template>

<script>
import '../style/vue-select.css';
import vSelect from 'vue-select'
import IconButton from "./IconButton";

export default {
    name: "SelectSearchInput",
    components: {IconButton, vSelect},
    props: {
        models: {
            type: Array,
            required: true,
        },
        addQuantity: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
        },
        fetchName: {
            type: String,
            required: true,
        },
        getAllGetterName: {
            type: String,
            required: true,
        },
        getOneGetterName: {
            type: String,
            required: true,
        },
        // optional
        afterFetch: {
            type: Function,
            default: function () {
            }
        },
        amountName: {
            type: String,
            default: "amount",
        },
        afterPush: {
            type: Function,
            default: function (item) {
                console.log(item)
            }
        },
        clearable: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: "cart-arrow-down",
        },
        saleProductDtos: {
            type: Array,
            default() {
                return []
            }
        },
    },
    mounted() {
        this.$store
            .dispatch(this.fetchName, null)
            .then(() => {
                this.options = this.$store.getters[this.getAllGetterName]
                this.afterFetch(this.options)
            })
    },
    methods: {
        getLabel(option) {
            return (option && option.product.name) || ''
        },
        pushToModels() {
            this.selected.constQuantity = +this.selected.constQuantity
            this.selected.quantity = +this.selected.quantity
            this.selected.quantity = this.selected.constQuantity


            if (this.selected.quantity === undefined) {
                this.selected.quantity = 0
            }

            if (this.saleProductDtos !== []) {
                for (let productDto of this.saleProductDtos) {
                    if (this.selected.id === productDto.id) {
                        this.selected.quantity = this.selected.quantity + 1
                    }
                }
            }

            if (this.models.length > 0) {
                let modelsLength = 0

                this.models.forEach((item) => {
                    if (this.selected.id === item.id) {
                        this.arrayItem = this.models.splice(modelsLength, 1)
                    }
                    modelsLength++
                })

                if (this.arrayItem.length > 0 && this.selected.id === this.arrayItem[0].id) {
                    this.addQuantity.push(this.selected)
                    this.models.push(this.selected)
                    this.afterPush(this.selected)
                    this.arrayItem = []
                } else {
                    this.selected[this.amountName] = 1
                    this.models.push(this.selected)
                    this.afterPush(this.selected)
                }
            } else {
                this.selected[this.amountName] = 1
                this.models.push(this.selected)
                this.afterPush(this.selected)
            }

            this.unit();
        },
        fetchOptions() {
            if (this.searchInput.length === 13) {
                let product = this.options.find(product => this.searchInput === product.product.barCode)

                if (product !== null) {
                    this.selected = product
                    this.searchInput = ''
                    this.pushToModels()
                }
            }
        },
        unit() {
            for (let saleProductDto of this.saleProductDtos) {
                let unitOfMeasures = []
                if (saleProductDto.product.additionalUnitOfMeasures.length !== 0) {
                    unitOfMeasures.push({
                        unitOfMeasure: this.showUnitOfMeasure(saleProductDto.product.unitOfMeasure),
                        howMany: 1,
                        quantity: 1
                    })

                    for (let additionalUnitOfMeasure of saleProductDto.product.additionalUnitOfMeasures) {
                        unitOfMeasures.push({
                            unitOfMeasure: this.showUnitOfMeasure(additionalUnitOfMeasure.unitOfMeasure),
                            howMany: parseInt(additionalUnitOfMeasure.howMany),
                            quantity: 1
                        })
                    }

                    saleProductDto.unitOfMeasures = unitOfMeasures
                }
            }
        },
        showUnitOfMeasure(unit) {
            if (unit === undefined) {
                return ''
            }

            if (Object.prototype.hasOwnProperty.call(this.$i18n.messages.en.unitOfMeasure, unit)) {
                return this.$t('unitOfMeasure.' + unit)
            }

            return unit
        },
    },
    data() {
        return {
            searchInput: '',
            options: [],
            selected: null,
            arrayItem: [],
        }
    },
}

</script>

<style scoped>

</style>